import styled from 'styled-components';

export const Container = styled.div`
  text-align: center;
  & > .hefesto-icon {
    svg {
      margin-top: 2.6rem;
      margin-bottom: 1.35rem;
      width: 5rem;
      height: 4.25rem;
    }
  }
  & > .text {
    margin: 0 33.125rem 1rem 33.125rem;
  }
  p {
    margin: 0;
  }
`;
